import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import useStyles from './styles';

export default function ConfirmationInfo({
  selectedProductAssociation,
  viewedProductGroup,
}) {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead className={classes.horizontalTable}>
          <TableCell>
            {viewedProductGroup.number}
          </TableCell>
          <TableCell>
            {selectedProductAssociation?.groupNumber}
          </TableCell>
        </TableHead>
        <TableBody className={classes.horizontalTable}>
          <TableRow className={classes.verticalTable}>
            {viewedProductGroup?.products?.map(
              (product) => <TableCell key={product.id}>{product.description}</TableCell>,
            )}
          </TableRow>
          <TableRow>
            {selectedProductAssociation?.groupProducts?.map(
              (product) => <TableCell key={product.id}>{product.description}</TableCell>,
            )}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ConfirmationInfo.propTypes = {
  selectedProductAssociation: PropTypes.shape({
    groupIRI: PropTypes.string.isRequired,
    groupNumber: PropTypes.string.isRequired,
    groupProducts: PropTypes.arrayOf(PropTypes.any).isRequired,
  }).isRequired,
  viewedProductGroup: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any),
  ]).isRequired,
};
